import React from 'react'

export default function EvaluationNoData({ Title, Subtitle = 'No Evaluation Found' }) {
    return (
        <div className=" col-md-6 px-0 border-end justify-content-center">
            <h5 className="border border-end-0 border-start-0 tt-bold font-15 ps-4 py-4 mb-0 border-top-0">
                {Title}
            </h5>
            <div style={{ display: "flex", alignItems: "center", flexDirection: "column" }}>
                <img
                    src="/Images/nodatafound.png"
                    alt="nodatafound"
                    className="nofeedbackimg-sty eva-custom-width"
                />
                <h2 className="tt-bold font-15 text-center margin-negative mb-5">{Subtitle}</h2>
            </div>

        </div>
    )
}
